import { AbstractControl, ValidatorFn } from '@angular/forms';
import { tap } from 'rxjs/operators';

import { EMAIL_REGEXP, EMAIL_REGEXP_WITH_DOT } from '@shared/constants/email.regexp.const';

export const EmailPatternValidator = (requireDot = false): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control?.value) {
      return null;
    }

    return requireDot
      ? EMAIL_REGEXP_WITH_DOT.test(control.value)
        ? null
        : { email: true }
      : EMAIL_REGEXP.test(control.value)
      ? null
      : { email: true };
  };
};

export const correctEmailInput = (control: AbstractControl) => {
  return control.valueChanges.pipe(
    tap(email => {
      const trimmed = email.trim();
      if (trimmed !== email) {
        control.setValue(trimmed);
      }
    })
  );
};
